import { FC } from "react";
import { Layout } from 'react-admin';

import { AdminMenu } from "./AdminMenu";

export const AdminLayout: FC = (props) => (
  <Layout
    {...props}
    menu={AdminMenu} />
);